export const TabelClassname = {
    PrimaryTabel: 'table  text-center',
}